let projectsJson = {
  "projects": [
    {
      id: 1,
      name: "Portfolio",
      desc: "",
      image: "../assets/images/projects/portfolio.png",
      links: {
        view: "https://giannimanilia.github.io/",
        code: "https://github.com/giannimanilia/giannimanilia.github.io"
      },
    },
    {
      id: 2,
      name: "UniApp USB",
      desc: "",
      image: "../assets/images/projects/uniapp-usb.png",
      links: {
        view: null,
        code: null
      },
    },
    {
      id: 3,
      name: "PokeData",
      desc: "",
      image: "../assets/images/projects/pokedata.png",
      links: {
        view: null,
        code: "https://github.com/giannimanilia/pokedata"
      },
    },
    {
      id: 4,
      name: "Sudoku Solver",
      desc: "",
      image:"../assets/images/projects/sudoku-solver.png",
      links: {
        view: null,
        code: "https://github.com/giannimanilia/sudoku-solver"
      },
    },
    {
      id: 5,
      name: "Notes",
      desc: "",
      image: "../assets/images/projects/notes.png",
      links: {
        view: null,
        code: "https://github.com/giannimanilia/notes-backend"
      },
    },
    {
      id: 6,
      name: "Flappy Hermes",
      desc: "",
      image: "../assets/images/projects/flappy-hermes.png",
      links: {
        view: null,
        code: "https://github.com/giannimanilia/flappy-hermes"
      },
    }
  ]
};

export default projectsJson
